import { siteDate, siteWeekday, siteTickerItems } from '@/mocks/home';

export default function TopStrip() {
  const loop = [...siteTickerItems, ...siteTickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-9 w-full items-center gap-5 px-4 md:px-6">
        <span className="hidden shrink-0 items-center gap-1.5 text-xs text-background-50/80 sm:flex">
          <i className="ri-calendar-line text-accent-400" aria-hidden="true"></i>
          {siteDate} {siteWeekday}
        </span>
        <span className="hidden h-3 w-px bg-background-50/25 sm:block" aria-hidden="true"></span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center gap-10 whitespace-nowrap">
            {loop.map((item, index) => (
              <span key={`ticker-${index}`} className="flex items-center gap-2 text-xs text-background-50/85">
                <i className="ri-megaphone-line text-accent-400" aria-hidden="true"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-1.5 text-xs text-background-50/70 md:flex">
          <i className="ri-refresh-line" aria-hidden="true"></i>
          每日 09:00 更新
        </span>
      </div>
    </div>
  );
}